var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 44,
    viewBox: "0 0 75 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "light_new",
    "data-name": "light new",
    transform: "translate(-4094 -10816)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2744",
    "data-name": "Rectangle 2744",
    width: 75,
    height: 44,
    rx: 2,
    transform: "translate(4094 10816)",
    fill: "#e6e7ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2745",
    "data-name": "Rectangle 2745",
    width: 11,
    height: 3,
    rx: 0.5,
    transform: "translate(4142 10843)",
    fill: "#00db6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2746",
    "data-name": "Rectangle 2746",
    width: 11,
    height: 3,
    rx: 0.5,
    transform: "translate(4155 10843)",
    fill: "#ff4033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2747",
    "data-name": "Rectangle 2747",
    d: "M2,0H73a2,2,0,0,1,2,2V4a0,0,0,0,1,0,0H0A0,0,0,0,1,0,4V2A2,2,0,0,1,2,0Z",
    transform: "translate(4094 10816)",
    fill: "#ccced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2748",
    "data-name": "Rectangle 2748",
    width: 24,
    height: 2,
    rx: 0.5,
    transform: "translate(4142 10823)",
    fill: "#ccced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2749",
    "data-name": "Rectangle 2749",
    width: 24,
    height: 2,
    rx: 0.5,
    transform: "translate(4142 10827)",
    fill: "#ccced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2750",
    "data-name": "Rectangle 2750",
    width: 24,
    height: 2,
    rx: 0.5,
    transform: "translate(4142 10831)",
    fill: "#ccced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2751",
    "data-name": "Rectangle 2751",
    width: 24,
    height: 2,
    rx: 0.5,
    transform: "translate(4142 10835)",
    fill: "#ccced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2752",
    "data-name": "Rectangle 2752",
    width: 24,
    height: 2,
    rx: 0.5,
    transform: "translate(4142 10839)",
    fill: "#ccced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2753",
    "data-name": "Rectangle 2753",
    width: 43,
    height: 8,
    rx: 1,
    transform: "translate(4097 10848)",
    fill: "#ccced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2754",
    "data-name": "Rectangle 2754",
    width: 24,
    height: 8,
    rx: 1,
    transform: "translate(4142 10848)",
    fill: "#ccced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2755",
    "data-name": "Rectangle 2755",
    width: 43,
    height: 23,
    rx: 1,
    transform: "translate(4097 10823)",
    fill: "#ccced9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightNew);
export default __webpack_public_path__ + "static/media/light-new.b025132b9be1691b0ceb3a070938b2d0.svg";
export { ForwardRef as ReactComponent };